import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { DateSelectionModelChange } from '@angular/material/datepicker';
import { Subject } from 'rxjs';
import { APIService } from '../api.service';
import { DataService } from '../data.service';
import { FunctionService } from '../function.service';
import { Player, Setting } from '../Main.Model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-rankings',
    templateUrl: './rankings.component.html',
    styleUrls: ['./rankings.component.css'],
    standalone: false
})
export class RankingsComponent implements OnInit {

  //@Input() Settings;

  //@Output() PlayerHistoryEmit = new EventEmitter<number>();
  //GetSettings: Subject<Setting[]>//when subscribed this populates
  RankingMale: boolean = true;
  RankingFemale: boolean = true;
  RankingNZ: boolean = true;
  RankingSort: string = 'Singles';
  Rankings: any;
  Played: string = 'Zero';
  Today: object;
  PlayersLoaded: Subject<boolean>//when subscribed this populates
  MatchesLoaded: Subject<boolean>//when subscribed this populates
  boolWaitingForPlayersAndMatchesToBeLoaded: boolean = false

  constructor(private ref: ChangeDetectorRef, public DataService: DataService, private FunctionService: FunctionService, private router: Router) { 
    this.PlayersLoaded = this.DataService.PlayersLoaded;
    this.MatchesLoaded = this.DataService.MatchesLoaded;
  }

  async ngOnInit() {
    if (!this.DataService.Matches) {
        await this.DataService.refreshMatches();
    }
    if (this.DataService.Players && this.DataService.Matches) {//Players & Matches are being loaded at startup but take some time so might still be loading....
        if (this.DataService.Players.length > 0 && this.DataService.Matches.length > 0) {
            this.ReCreateRankings('Singles');//will not work if Players not loaded yet....
        } else {
            this.boolWaitingForPlayersAndMatchesToBeLoaded = true;//if not loaded yet then enter state of waiting
        }
    } else {
        this.boolWaitingForPlayersAndMatchesToBeLoaded = true;
    }
    this.PlayersLoaded.subscribe(value => {
        console.log('Players have been retrieved');
        if (this.boolWaitingForPlayersAndMatchesToBeLoaded == true) {
            this.boolWaitingForPlayersAndMatchesToBeLoaded = false;
            this.ReCreateRankings('Singles');
        }
    });
    this.MatchesLoaded.subscribe(value => {
        console.log('Matches have been retrieved');
        if (this.boolWaitingForPlayersAndMatchesToBeLoaded == true) {
            this.boolWaitingForPlayersAndMatchesToBeLoaded = false;
            this.ReCreateRankings('Singles');
        }
    });
  }

  ReCreateRankings(RankingSort) {
    this.Rankings = [];
    
    this.calcRankings();

    for (var r = 0; r < this.DataService.Players.length; r++) {
      var Player = this.DataService.Players[r];
      if ((Player.gender == 'M' && this.RankingMale == true) || (Player.gender == 'F' && this.RankingFemale == true)) {
        if ((Player.hasPlayedSingles == true && RankingSort == 'Singles') || (Player.hasPlayedDoubles == true && RankingSort == 'Doubles') || Player.gradingReviewed == false) {
          if ((this.RankingNZ == true && (Player.country == 'NZ' || Player.country == 'New Zealand')) || this.RankingNZ == false) {
              if (this.Played == 'Zero' || (this.Played == 'Last1Year' && ((Player.hasPlayedSinglesInLastYear == true && RankingSort == 'Singles') || (Player.hasPlayedDoublesInLastYear == true && RankingSort == 'Doubles'))) || (this.Played == 'Last2Years' && (((Player.hasPlayedSinglesInLast2Years == true && RankingSort == 'Singles') || (Player.hasPlayedDoublesInLast2Years == true && RankingSort == 'Doubles'))))) {
                if (Player.singlesPoints > 0) {//otherwise it shows the BYE
                    this.Rankings.push(Player);
                }
              }
          }
        }
      }
    }
    if (RankingSort == 'Singles') {
        this.Rankings.sort(function(a, b) { return b.singlesPoints - a.singlesPoints });
    } else {
        this.Rankings.sort(function(a, b) { return b.doublesPoints - a.doublesPoints });
    }
    this.ref.detectChanges();
  }

  calcRankings() {
    for (var p = 0; p < this.DataService.Players.length; p++) {
        this.DataService.Players[p] = this.FunctionService.CalcAPlayersRankingData(this.DataService.Players[p], this.Played);
    }
    //this.PleaseCalculateTheRankings = false;
  }

  newPLayerHighlightInRankings (player) {
    if (player.GradingReviewed == false) {
      return 'green';
    }
  }

  ViewHistoryOfPlayer (Player) {
    this.DataService.SelectedPlayer = Player;
    //this.DataService.changeMainStatus('History');
    //navigate to player history page
    this.router.navigate(['/player-history'], { queryParams: { id: Player.id } });

  }

  ratingClass(value: number) {
    if (value > 80) return 'VeryHighRating';
    if (value > 70) return 'highRating';
    return '';
  }
  
}
